import React from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ForwardCustomer from "../ForwardCustomer/ForwardCustomer";
import ResumeCustomer from "../ResumeCustomer/ResumeCustomer";

export default function SimpleMenu({ customer }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{
          marginTop: "55px",
          marginLeft: "-36px",
        }}
      >
        <MenuItem>
          <ForwardCustomer customer={customer} />
        </MenuItem>

        {customer?.resume && (
          <MenuItem>
            <ResumeCustomer customer={customer} />
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
